import { useQuery } from '@tanstack/react-query';
import { getDocumentTemplate } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useDocumentTemplateQuery = (id: string | undefined) => {
	return useQuery({
		queryKey: [API_PATHS.DOCUMENT_TEMPLATES_ID_GET, { id }],
		queryFn: ({ signal }) => getDocumentTemplate(id ?? '', signal),
		enabled: !!id,
	});
};
